import { InputAdornment, CircularProgress, useTheme } from '@mui/material';

const LoadingAdornment = () => {
  const theme = useTheme();

  return (
    <InputAdornment position="end">
      <CircularProgress size={theme.spacing(3)} />
    </InputAdornment>
  );
};

export default LoadingAdornment;
